var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tags"}},[_c('organization-tags',{attrs:{"loading":_vm.loader.on}}),_c('space-tags',{attrs:{"loading":_vm.loader.on}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }